/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

export const CLEAR_ACCOUNT = '@@wsp/account/CLEAR'
export const SET_ACCOUNT_EMAIL = '@@wsp/account/SET_EMAIL'
export const SET_ACCOUNT_NEXT = '@@wsp/account/SET_NEXT'
